import * as React from "react";
import {CSSProperties} from "react";
import {Icon} from "antd";
import locales from "../locales";
import {COST_BEARER_OWN, COST_BEARER_RENTER, MaintenanceHistory} from "../api/dtos/dtos";

const greenIconStyle: CSSProperties = {
  // Note: this changes the internal svg icon size as well
  fontSize: 16,
  color: '#4DA20F'
};

const redIconStyle: CSSProperties = {
  // Note: this changes the internal svg icon size as well
  fontSize: 16,
  color: '#f04134'
};

export const renderHandledIcon = (handled: boolean) => {
  return handled
    ? <Icon type="file-done" theme="outlined" style={greenIconStyle} title={locales.handled}/>
    : <Icon type="file-exclamation" theme="outlined" style={redIconStyle} title={locales.not_handled}/>
}

export const renderMaintenanceNameCell = (item: MaintenanceHistory) => {
  const {name, attachmentCount} = item;
  return (
    <div style={{display: "grid"}}>
      {name}
      {attachmentCount > 0 && <span className="attachments">{attachmentCount} {locales.attachment}</span>}
    </div>
  );
};

const stateToText = {
  [COST_BEARER_OWN]: locales.cost_own_short,
  [COST_BEARER_RENTER]: locales.cost_renter_short,
};

export const getCostBearerFilters = () => {
  return [COST_BEARER_OWN, COST_BEARER_RENTER]
    .map(state => ({text: stateToText[state], value: state}))
}


// WEBPACK FOOTER //
// ./src/maintenance/MaintenanceUtils.tsx